import request from "./request.js";

export default {
  // 标记推广
  markPromotion: (data) => {
    return request({
      url: "api/admin/promotion/markPromotion",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  // 查看推广记录
  getPromotion: (data) => {
    return request({
      url: "api/admin/promotion/getPromotion",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
};
